export const TAG_REGEX = /([\w]+(,|\n))/g;
export const CHECK_VAR_REGEX = /(\{([\w]+)\|([^}]*?))|(([^}]*?)\})/g;
